export default __webpack_public_path__ + "static/media/danceofdeath.a10a994e.png";